/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shifts_LiveDiaperCheckDTO } from './shifts_LiveDiaperCheckDTO';
/**
 * Live coverage details for a single group: children checked in now against staff on shift now.
 */
export type shifts_LiveGroupCoverageDTO = {
    /**
     * ActivitySince is the newest entry of any child present in the group today, any type,
     * check-in included (care alerts, activity gap); null without present children.
     */
    activity_since: string | null;
    /**
     * ActivityState: ok (under 75 % of the threshold), due_soon, overdue (the group lead is
     * told), escalated (the lead's head is told); null while the organisation has the
     * activity gap alert off, so the time is shown without a colour.
     */
    activity_state: shifts_LiveGroupCoverageDTO.activity_state | null;
    breach_kind: shifts_LiveGroupCoverageDTO.breach_kind | null;
    /**
     * BreachSince is the start of the group's confirmed coverage breach (two sweep runs with
     * fewer staff in the group than required while children are present); null when there is
     * none or group presence is off. BreachKind says whether staff (head_count) or qualified
     * staff (qualified) are missing.
     */
    breach_since: string | null;
    childcare_id?: string;
    coverage_percent: number;
    /**
     * DiaperChecks is the diaper clock of every present child flagged "uses diapers" (care
     * alerts), the longest-running clock first; empty while the organisation has the
     * diaper check off.
     */
    diaper_checks: Array<shifts_LiveDiaperCheckDTO>;
    expected_children: number;
    group_id: string;
    group_name: string;
    in_group_qualified_staff: number | null;
    /**
     * InGroupStaff, InGroupQualifiedStaff and InGroupVerdict count the employees who
     * recorded in the app that they are in this group now (group presence, #2113),
     * judged by the same staffing rules. null when the organisation's switch is off; the
     * plan-based fields above never change because of them.
     */
    in_group_staff: number | null;
    in_group_verdict: shifts_LiveGroupCoverageDTO.in_group_verdict | null;
    min_qualified_staff: number;
    present_children: number;
    present_qualified_staff: number;
    present_staff: number;
    qualified_shortfall: boolean;
    required_staff: number;
    scheduled_staff: number;
    staffing_model: string;
    status: shifts_LiveGroupCoverageDTO.status;
};
export namespace shifts_LiveGroupCoverageDTO {
    /**
     * ActivityState: ok (under 75 % of the threshold), due_soon, overdue (the group lead is
     * told), escalated (the lead's head is told); null while the organisation has the
     * activity gap alert off, so the time is shown without a colour.
     */
    export enum activity_state {
        OK = 'ok',
        DUE_SOON = 'due_soon',
        OVERDUE = 'overdue',
        ESCALATED = 'escalated',
    }
    export enum breach_kind {
        HEAD_COUNT = 'head_count',
        QUALIFIED = 'qualified',
    }
    export enum in_group_verdict {
        SUFFICIENT = 'SUFFICIENT',
        WARNING = 'WARNING',
        CRITICAL = 'CRITICAL',
        NO_CHILDREN = 'NO_CHILDREN',
        NOT_CONFIGURED = 'NOT_CONFIGURED',
    }
    export enum status {
        SUFFICIENT = 'SUFFICIENT',
        WARNING = 'WARNING',
        CRITICAL = 'CRITICAL',
        NO_CHILDREN = 'NO_CHILDREN',
        NOT_CONFIGURED = 'NOT_CONFIGURED',
    }
}

